// extracted by mini-css-extract-plugin
module.exports = {"valueLabelRoot":"valueLabelRoot--0e819"};